import { useShowLal } from '@openx/components-segment/lib/utils/useShowLal.ts';
import type { ListLalSegment, ListSegment } from '@openx/types/segments.ts';
import { useState } from 'react';

import { Navigate, Route, Routes } from 'react-router';
import { SegmentsList } from './components/SegmentsList.tsx';
import { SegmentsPageHeader } from './components/SegmentsPageHeader.tsx';
import { SegmentsTabs } from './components/SegmentsTabs.tsx';
import { useExportSegmentsDialog } from './hooks/useExportSegmentsDialog.tsx';
import { LalSegmentsList } from './lal/components/LalSegmentsList.tsx';

export const SegmentsListPage = () => {
  const [selectedSegments, setSelectedSegments] = useState<ListSegment[]>([]);
  const [selectedLalSegments, setSelectedLalSegments] = useState<ListLalSegment[]>([]);
  const showLal = useShowLal();
  const {
    open: openExportSegments,
    registerCriteria: registerExportCriteria,
    isExportDisabled,
  } = useExportSegmentsDialog();

  const handleTabChange = () => {
    setSelectedSegments([]);
    setSelectedLalSegments([]);
  };

  return (
    <SegmentsPageHeader
      selectedSegments={selectedSegments}
      setSelectedSegments={setSelectedSegments}
      selectedLalSegments={selectedLalSegments}
      setSelectedLalSegments={setSelectedLalSegments}
      onExportSegments={openExportSegments}
      isExportDisabled={isExportDisabled}
    >
      <SegmentsTabs onTabChange={handleTabChange} />
      <Routes>
        <Route
          path="audience"
          element={
            <SegmentsList
              selectedSegments={selectedSegments}
              setSelectedSegments={setSelectedSegments}
              registerExportCriteria={registerExportCriteria}
            />
          }
        />
        {showLal && (
          <Route
            path="lookalike"
            element={
              <LalSegmentsList selectedSegments={selectedLalSegments} setSelectedSegments={setSelectedLalSegments} />
            }
          />
        )}
        <Route path="*" element={<Navigate to="/segments/audience" replace />} />
      </Routes>
    </SegmentsPageHeader>
  );
};
